import i18next, { ParseKeys, use } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from 'translations/en.json';

const getVariationOfAOrAn = (value: string, capitalize: boolean) => {
    const letters = ['A', 'E', 'I', 'O', 'U', 'H', 'a', 'e', 'i', 'o', 'u', 'h'];
    const firstLetter = value.substring(0, 1);
    if (
        letters.find(function (l) {
            return firstLetter === l;
        })
    ) {
        return capitalize ? 'An' : 'an';
    }
    return capitalize ? 'A' : 'a';
};

export const defaultNS = 'translations';

export const resources = {
    'en-US': { Name: 'English (US)', translations: en },
    'en-GB': { Name: 'English (UK)', translations: en }
};

// eslint-disable-next-line react-hooks/rules-of-hooks
await use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: ['en-US'],
        detection: {
            order: ['cookie', 'localStorage', 'navigator'],
            caches: ['cookie', 'localStorage']
        },
        defaultNS,
        resources,
        returnNull: false,
        interpolation: {
            escapeValue: false
        }
    });

i18next.services.formatter?.add('uppercase', (value: string) => value.toUpperCase());
i18next.services.formatter?.add('lowercase', (value: string) => value.toLowerCase());
i18next.services.formatter?.add('en-handle-an', (value: string, lng) =>
    !lng || lng === 'en' ? getVariationOfAOrAn(value, false) : ''
);
i18next.services.formatter?.add('en-handle-an-capitalized', (value: string, lng) =>
    !lng || lng === 'en' ? getVariationOfAOrAn(value, true) : ''
);
i18next.services.formatter?.add('en-handle-lowercase', (value: string, lng) =>
    !lng || lng === 'en' ? value.toLowerCase() : value
);

declare module 'i18next' {
    interface CustomTypeOptions {
        defaultNS: typeof defaultNS;
        resources: (typeof resources)['en-US'];
        returnNull: false;
    }
}

export type TranslationKeys = ParseKeys<'translations'>;

export const i18n = i18next;
